import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Dashboard from "./pages/Dashboard";
import Departments from "./pages/Departments";
import Programs from "./pages/Programs";
import Login from "./pages/Login";
import AddLesson from "./pages/AddLesson";
import AddUnit from "./pages/AddUnit";

const App = () => {
  const token = localStorage.getItem("accessToken");

  return (
    <Router>
      {token && <Navbar />} {/* Show Navbar only when logged in */}

      <div className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* ✅ Protected Routes */}

          <Route
            path="/dashboard"
            element={token ? <Dashboard /> : <Navigate to="/login" />}
          />

          <Route
            path="/departments"
            element={token ? <Departments /> : <Navigate to="/login" />}
          />

          <Route
            path="/programs"
            element={token ? <Programs /> : <Navigate to="/login" />}
          />
           {/* ✅ Add this Route here (protected) */}
          <Route
            path="/add-unit"
            element={token ? <AddUnit /> : <Navigate to="/login" />}
          />

          {/* ✅ Add this Route here (protected) */}
          <Route
            path="/add-lesson"
            element={token ? <AddLesson /> : <Navigate to="/login" />}
          />

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>

      {token && <Footer />} {/* Show Footer only when logged in */}
    </Router>
  );
};

export default App;

